export const TOGGLE_THEME = 'TOGGLE_THEME';
export const TOGGLE_DATA_UPLOAD_DIALOG = 'TOGGLE_DATA_UPLOAD_DIALOG';
export const TOGGLE_NAV_DRAWER = 'TOGGLE_NAV_DRAWER';
export const SET_TABLE_SELECTED = 'apptable/SET_TABLE_SELECTED';
export const SET_NAV_HEADER = 'apptable/SET_NAV_HEADER';
export const TOGGLE_FILTER_TABLE = 'filtertable/TOGGLE_FILTER_TABLE';
export const CHANGE_PASSWORD = 'auth/CHANGE_PASSWORD';